'use client';

import { RefObject, useImperativeHandle, useState } from 'react';
import clsx from 'clsx';
import { Component } from '@headless-workspace/typings';
import { ComposableToast, getToastConfig, GlowToastProps } from '../../composables';

export type ToasterHandle = {
    showToaster?: () => void;
};

type GlowInlineToastProps = GlowToastProps & {
    hasCloseBtn?: boolean;
    ref?: RefObject<ToasterHandle | null>;
    crossIconAccessibilityTitle?: string;
};

export const GlowInlineToast: Component<GlowInlineToastProps> = ({
    toastType,
    label,
    className,
    hasCloseBtn,
    ref,
    crossIconAccessibilityTitle,
    ...props
}) => {
    const { toastIcon, backgroundClassName, role, ariaLive } = getToastConfig(toastType);
    const [isVisible, setIsVisible] = useState(true);

    const handleClose = () => setIsVisible(false);
    const handleOpen = () => setIsVisible(true);

    useImperativeHandle(ref, () => ({
        showToaster: () => {
            !isVisible && handleOpen();
        },
    }));

    if (!isVisible) {
        return null;
    }

    return (
        <ComposableToast.Container
            ariaLive={ariaLive}
            className={clsx(className, backgroundClassName)}
            role={role}
            {...props}
        >
            <ComposableToast.Icon Icon={toastIcon} />
            <ComposableToast.Label label={label} />
            {hasCloseBtn && (
                <ComposableToast.CloseButton onClose={handleClose} accessibilityTitle={crossIconAccessibilityTitle} />
            )}
        </ComposableToast.Container>
    );
};
